import {useEffect} from 'react';
import dayjs from 'dayjs';

import {KpiGroupByValuesType, getGroupBySettings} from '../common/kpiUtils';

/**
 * This hook is used to keep track on the running time in the dashboard
 * It works also with the dashboardTime passed by the Time Drive in ng-ui
 * If no dashboard time is set, it calls the reload function
 * every time, a period defined by the groupBy option in the settings ends so the chart is updated
 * e.g. after every hour
 * @param dashboardTime - dashboard time - only set if time drive is active
 * @param periodType - the period (type) that is the parameter for the update interval - e.g. if the period type is HOUR the chart get updated on every hour change
 * @param lastUpdate - last update timestamp
 * @param reload - triggers reload of values
 */
const useTimer = (
	dashboardTime: number | null | undefined,
	periodType: KpiGroupByValuesType,
	lastUpdate: number | null | undefined,
	reload: () => void
) => {
	useEffect(
		() => {
			if (!dashboardTime) {
				const momentSettings = getGroupBySettings(periodType);
				const endOfPeriod = dayjs(lastUpdate || undefined).endOf(momentSettings.momentTimeUnit);
				// the time from now until the end of the period.
				// we need to update the first time if the current period has ended
				const timeout = dayjs.duration(endOfPeriod.diff(dayjs())).asMilliseconds();
				const timeoutId = setTimeout(reload, timeout);
				return () => clearTimeout(timeoutId);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[dashboardTime, periodType, reload]
	);
};

export default useTimer;
